const shipment = {
  shipmentMana: '發貨需求',
  shipmentListPage: '發貨單',
  add: '添加',
  edit: '編輯',
  delete: '刪除',
  detail: '詳情',
  export: '導出',
  import: '導入',
  search: '查詢',
  reset: '重置',
  confirm: '確認',
  cancel: '取消',
  cancelOk: '取消成功',
  cancelFAil: '取消失敗',
  confirmCancel: '是否取消發貨單{{no}}嗎？',
  orderNumber: '訂單編號',
  customerName: '客戶名稱',
  status: '狀態',
  sourceType: '來源類型',
  consignee: '收貨人',
  consigneeAddress: '收貨地址',
  consigneePhone: '收貨電話',
  destinationCountry: '目的國家',
  tradeTerms: '貿易條款',
  paymentTerms: '付款方式',
  planShipDate: '計劃發貨日期',
  actualShipDate: '實際發貨日期',
  deliveredAt: '送達時間',
  remark: '備註',
  items: '明細',
  createTime: '創建時間',
  operation: '操作',
  productCode: '商品編碼',
  productName: '商品名稱',
  count: '數量',
  saleOrderCount: '銷售單數量',
  amount: '金額',
  uom: '單位',
  unitPrice: '單價',
  currency: '幣種',
  itemRemark: '備註',
  plKeyword: '請輸入訂單編號或客戶名稱',
  shipMethod: '發貨方式',
  shipLogistics: '承運人',
  shipEvent: '物流軌跡',
  saleOrder: '銷售訂單',
  saleOrderItem: '銷售訂單條目',
  selectOrder: '選擇訂單',
  selectOrderItem: '選擇訂單條目',
  noProduct: '沒有商品',
  customerShipAddress: '選擇收貨地址',
  plCustomerName: '請輸入客戶名稱',
  plConsignee: '請輸入收貨人',
  plConsigneePhone: '請輸入收貨電話',
  plConsigneeAddress: '請輸入收貨地址',
  plRemark: '請輸入備註',
  plTradeTerms: '請輸入貿易條款',
  plPaymentTerms: '請輸入付款方式',
  plCurrency: '請輸入幣種',
  plCarrier: '請輸入承運人',
  addPackOrder: '添加分揀單',
  yes: '是',
  no: '否',
  number: '發貨單號',
  trackingNo: '物流單號',
  blNo: '提單號',
  vesselVoyage: '運次',
  containerNo: '集裝箱編號',
  shipped: '已發貨',
  pending: '待發貨',
  shippedAt: '發貨時間',
  freightCost: '運費',
  addLogistics: '添加物流',
  editLogistics: '編輯物流',
  plTrackingNo: '請輸入物流單號',
  plBlNo: '請輸入提單號',
  plVesselVoyage: '請輸入船次/航次/班次',
  plContainerNo: '請輸入集裝箱編號',
  plFreightCost: '請輸入運費',
  addError: '添加失敗',
  saveFail: '保存失敗',
  saveOk: '保存成功',
  addSuccess: '添加成功',
  freightCurrency: '運費幣種',
  noPackOrder: '沒有分揀單',
  shipmentNoPack: '發貨單沒有分揀單，不能添加物流單',
  packNoShipment: '分揀單沒有發貨單，不能添加物流單',
  getPackErr: "獲取分揀單失敗！",
  logistics: "物流單",
  eventTime: '事件時間',
  location: '位置',
  description: '描述',
  shipEvents: '物流軌跡',
  plLocation: '請輸入位置',
  plDescription: '請輸入描述',
  addEvent: '添加軌跡',
  doShip: '發貨',
  shipOk: '發貨成功',
  shipFail: '發貨失敗',
  viewLogistics: '查看物流',
  creator: '創建人',
  viewPackOrder: '查看分揀單',
  viewShipmentOrder: '查看發貨單',
  repeated: '重複商品已忽略',
  addShipOutPl: "請先生成發貨出庫單！",
  hasLogis: "該發貨單已有物流",
  plSelShip: "請選擇發貨單",
  plSelShipErr: "只能選擇同一個分揀單生成的發貨單",
  exportErr: "導出失敗",
};

export default shipment;
